export const lightTheme = {
  body: '#FFF',
  text: '#2c2b2b',
  toggleBorder: '#FFF',
  background: '#363537',

  navBarBg: '#f8f9fa',
  navText: 'rgba(0,0,0,.5)',
  translateBg: '#f8f9fa',
  translateText: '#393939',

  powerMetricColor: '#C83DC5',
  offerLinksColor: '#C83DC5',

  footerColorLink: '#1b85f7',

  colorSpan: '#C83DC5',

  a: '#2c2b2b',
};
export const darkTheme = {
  body: '#363537',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  background: '#999',

  navBarBg: '#292829',
  navText: '#FAFAFA',
  translateBg: '#292829',
  translateText: '#FAFAFA',

  powerMetricColor: '#cd55e0',

  offerLinksColor: '#cd55e0',

  footerColorLink: '#73b4fa',

  colorSpan: '#cd55e0',

  a: '#fafafa',
};

export const redesignedDarkTheme = {
  ...darkTheme,
  body: '#110c17',
  navBarBg: '#110c17',
  translateBg: 'transparent',
  translateText: '#f94caf',
  powerMetricColor: '#f94caf',
  offerLinksColor: '#f94caf',
  colorSpan: '#f94caf',
};
